import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import _JSON$stringify from "@babel/runtime-corejs3/core-js-stable/json/stringify";
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
//
/* gloabl window */
import { Button, Icon, makeStyles, RaiseColors, Typography } from "client/componentLibrary";
import GlobalSnackbar from "components/GlobalMessageSnackbar/GlobalSnackbar";
import TextField from "components/mui/Fields/Fields/TextField/TextField";
import MuiFormikField from "dashboard/Invoicing/common/MuiFormikField";
import { Form, Formik } from "formik";
import isEmpty from "core/Utils/isEmpty";
import React from "react";
import * as Yup from "yup";
import LogoFormatContainer from "./LogoFormatContainer";
import Cookies from "js-cookie";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var useStyles = makeStyles(function (theme) {
  return {
    title: {
      fontSize: "20px",
      fontWeight: 500,
      color: RaiseColors.white
    },
    successfulTitle: {
      textAlign: "center",
      paddingBottom: "2px"
    },
    subtitle: {
      fontSize: "14px",
      paddingBottom: "16px",
      color: RaiseColors.white
    },
    errorText: {
      color: RaiseColors.warning,
      fontSize: "12px"
    },
    errorLabel: {
      color: RaiseColors.warning,
      fontSize: "13px",
      paddingBottom: "4px"
    },
    textLabels: {
      color: RaiseColors.white,
      fontSize: "13px"
    },
    errorMessage: {
      color: RaiseColors.warning,
      fontWeight: "normal",
      paddingBottom: "8px",
      lineHeight: "1.7"
    },
    errorConfirmPasswordText: {
      color: RaiseColors.warning,
      fontSize: "12px",
      paddingTop: "16px",
      paddingBottom: "4px"
    },
    confirmPasswordText: {
      paddingTop: "16px",
      color: RaiseColors.white,
      fontSize: "12px",
      paddingBottom: "4px"
    },
    focused: {
      borderColor: RaiseColors.shamrock
    },
    inputError: {
      borderColor: RaiseColors.warning
    },
    paddingContainer: {
      paddingLeft: "2px"
    }
  };
});
function EmployeePasswordChange() {
  var classes = useStyles();
  var _React$useState = React.useState(""),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    message = _React$useState2[0],
    setMessage = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    loading = _React$useState4[0],
    setLoading = _React$useState4[1];
  var _React$useState5 = React.useState(""),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    newPassword = _React$useState6[0],
    setNewPassword = _React$useState6[1];
  var _React$useState7 = React.useState(""),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    confirmPassword = _React$useState8[0],
    setConfirmedPassword = _React$useState8[1];
  var _React$useState9 = React.useState(false),
    _React$useState0 = _slicedToArray(_React$useState9, 2),
    successful = _React$useState0[0],
    setSuccessful = _React$useState0[1];
  var _React$useState1 = React.useState(false),
    _React$useState10 = _slicedToArray(_React$useState1, 2),
    isError = _React$useState10[0],
    setIsError = _React$useState10[1];
  var _React$useState11 = React.useState(null),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    snackBarMessage = _React$useState12[0],
    setSnackBarMessage = _React$useState12[1];
  var handleSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var newPassword, confirmPassword, postData, response, data, _t;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            newPassword = _ref.newPassword, confirmPassword = _ref.confirmPassword;
            postData = {
              new_password: newPassword,
              confirm_password: confirmPassword
            };
            setLoading(true);
            _context.prev = 1;
            _context.next = 2;
            return fetch("/ajax/accounts/change_password_on_login", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "X-CSRFToken": Cookies.get("csrftoken") || ""
              },
              body: _JSON$stringify(postData)
            });
          case 2:
            response = _context.sent;
            _context.next = 3;
            return response.json();
          case 3:
            data = _context.sent;
            if (response.ok && data.successful) {
              setSuccessful(true);
            } else {
              setMessage(data.message || "An unexpected error has occurred");
            }
            _context.next = 5;
            break;
          case 4:
            _context.prev = 4;
            _t = _context["catch"](1);
            setSnackBarMessage(/*#__PURE__*/_jsx("div", {
              className: classes.errorText,
              children: "An unexpected error has occurred"
            }));
          case 5:
            _context.prev = 5;
            setLoading(false);
            return _context.finish(5);
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 4, 5, 6]]);
    }));
    return function handleSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var ValidationSchema = Yup.object().shape({
    newPassword: Yup.string().nullable().min(8, "Password Length must be at least 8 characters."),
    confirmPassword: Yup.string().nullable().oneOf([Yup.ref("newPassword")], "Passwords did not match, please try again.")
  });
  var onFocusHandler = function onFocusHandler() {
    setIsError(false);
  };
  var onChangeHandler = function onChangeHandler(setErrors) {
    setErrors({});
  };
  var checkForEnter = function checkForEnter(_ref3) {
    var event = _ref3.event,
      validateForm = _ref3.validateForm,
      setTouched = _ref3.setTouched,
      values = _valuesInstanceProperty(_ref3);
    if (event.keyCode === 13) {
      validateForm().then(function (errors) {
        setTouched(errors);
        if (isEmpty(errors)) {
          handleSubmit(values);
        }
      });
    }
  };
  var hideMessage = function hideMessage() {
    setSnackBarMessage(null);
  };
  var focusedProps = {
    classes: {
      focused: classes.focused
    }
  };
  var errorProps = {
    classes: {
      root: classes.inputError,
      focused: classes.focused
    }
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(GlobalSnackbar, {
      variant: "error",
      message: snackBarMessage,
      onClose: hideMessage
    }), /*#__PURE__*/_jsx(LogoFormatContainer, {
      children: /*#__PURE__*/_jsx(Formik, {
        validationSchema: ValidationSchema,
        initialValues: {
          newPassword: newPassword,
          confirmPassword: confirmPassword
        },
        validateOnChange: false,
        onSubmit: handleSubmit,
        children: function children(formikUtils) {
          var values = _valuesInstanceProperty(formikUtils),
            handleChange = formikUtils.handleChange,
            submitForm = formikUtils.submitForm,
            errors = formikUtils.errors,
            setErrors = formikUtils.setErrors,
            validateForm = formikUtils.validateForm,
            setTouched = formikUtils.setTouched;
          return /*#__PURE__*/_jsx(_Fragment, {
            children: successful ? /*#__PURE__*/_jsxs(_Fragment, {
              children: [/*#__PURE__*/_jsx("div", {
                className: classes.paddingContainer,
                children: /*#__PURE__*/_jsx("div", {
                  className: classes.successfulTitle,
                  children: /*#__PURE__*/_jsx(Typography, {
                    weight: "semibold",
                    variant: "h3",
                    color: RaiseColors.white,
                    children: "You're all set."
                  })
                })
              }), /*#__PURE__*/_jsx(Button, {
                href: "/dashboard",
                variant: "SignInButton",
                children: loading ? /*#__PURE__*/_jsx(Icon, {
                  className: "fa fa-pulse fa-spinner"
                }) : "View Platform"
              })]
            }) : /*#__PURE__*/_jsxs(_Fragment, {
              children: [/*#__PURE__*/_jsxs("div", {
                className: classes.paddingContainer,
                children: [/*#__PURE__*/_jsx("div", {
                  className: classes.title,
                  children: "Set a password"
                }), message ? /*#__PURE__*/_jsx("div", {
                  className: classes.errorMessage,
                  children: message
                }) : /*#__PURE__*/_jsx("div", {
                  className: classes.subtitle,
                  children: "You'll use this to access your Platform"
                })]
              }), /*#__PURE__*/_jsxs(Form, {
                onKeyDown: function onKeyDown(event) {
                  checkForEnter({
                    validateForm: validateForm,
                    event: event,
                    values: values,
                    setTouched: setTouched
                  });
                },
                children: [/*#__PURE__*/_jsxs("div", {
                  className: classes.paddingContainer,
                  children: [/*#__PURE__*/_jsx("div", {
                    className: isError || errors.newPassword ? classes.errorLabel : classes.textLabels,
                    children: "New Password"
                  }), /*#__PURE__*/_jsx(MuiFormikField, {
                    Component: TextField,
                    fullWidth: true,
                    name: "newPassword",
                    id: "newPassword",
                    defaultValue: values.newPassword,
                    placeholder: "e.g. 8 characters long min.",
                    type: "password",
                    onChange: function onChange(e) {
                      onChangeHandler(setErrors);
                      handleChange(e);
                    },
                    onFocus: onFocusHandler,
                    InputProps: isError || errors.newPassword ? errorProps : focusedProps
                  }), /*#__PURE__*/_jsx("div", {
                    className: isError || errors.confirmPassword ? classes.errorConfirmPasswordText : classes.confirmPasswordText,
                    children: "Reenter New Password"
                  }), /*#__PURE__*/_jsx(MuiFormikField, {
                    Component: TextField,
                    fullWidth: true,
                    name: "confirmPassword",
                    id: "confirmPassword",
                    defaultValue: values.confirmPassword,
                    placeholder: "e.g. 8 characters long min.",
                    type: "password",
                    onChange: function onChange(e) {
                      onChangeHandler(setErrors);
                      handleChange(e);
                    },
                    onFocus: onFocusHandler,
                    InputProps: isError || errors.confirmPassword ? errorProps : focusedProps
                  })]
                }), /*#__PURE__*/_jsx(Button, {
                  onClick: function onClick() {
                    if (values.newPassword === "" || values.confirmPassword === "") {
                      setIsError(true);
                    } else {
                      submitForm();
                    }
                  },
                  variant: "SignInButton",
                  children: loading ? /*#__PURE__*/_jsx(Icon, {
                    className: "fa fa-pulse fa-spinner"
                  }) : "Set Password"
                })]
              })]
            })
          });
        }
      })
    })]
  });
}
export default EmployeePasswordChange;